// @generated by protoc-gen-es v2.13.0 with parameter "target=ts"
// @generated from file plugnmeet_polls.proto (package plugnmeet, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file plugnmeet_polls.proto.
 */
export const file_plugnmeet_polls: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message plugnmeet.ActivatePollsReq
 */
export type ActivatePollsReq = Message<"plugnmeet.ActivatePollsReq"> & {
  /**
   * @generated from field: string room_id = 1;
   */
  roomId: string;

  /**
   * @generated from field: bool is_active = 2;
   */
  isActive: boolean;
};

/**
 * Describes the message plugnmeet.ActivatePollsReq.
 * Use `create(ActivatePollsReqSchema)` to create a new message.
 */
export const ActivatePollsReqSchema: GenMessage<ActivatePollsReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_polls, 0);

/**
 * @generated from message plugnmeet.CreatePollReq
 */
export type CreatePollReq = Message<"plugnmeet.CreatePollReq"> & {
  /**
   * @generated from field: string room_id = 1;
   */
  roomId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string poll_id = 3;
   */
  pollId: string;

  /**
   * @generated from field: string question = 4;
   */
  question: string;

  /**
   * @generated from field: repeated plugnmeet.CreatePollOptions options = 5;
   */
  options: CreatePollOptions[];
};

/**
 * Describes the message plugnmeet.CreatePollReq.
 * Use `create(CreatePollReqSchema)` to create a new message.
 */
export const CreatePollReqSchema: GenMessage<CreatePollReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_polls, 1);

/**
 * @generated from message plugnmeet.CreatePollOptions
 */
export type CreatePollOptions = Message<"plugnmeet.CreatePollOptions"> & {
  /**
   * @generated from field: uint32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string text = 2;
   */
  text: string;
};

/**
 * Describes the message plugnmeet.CreatePollOptions.
 * Use `create(CreatePollOptionsSchema)` to create a new message.
 */
export const CreatePollOptionsSchema: GenMessage<CreatePollOptions> = /*@__PURE__*/
  messageDesc(file_plugnmeet_polls, 2);

/**
 * @generated from message plugnmeet.PollInfo
 */
export type PollInfo = Message<"plugnmeet.PollInfo"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string room_id = 2;
   */
  roomId: string;

  /**
   * @generated from field: string question = 3;
   */
  question: string;

  /**
   * @generated from field: repeated plugnmeet.CreatePollOptions options = 4;
   */
  options: CreatePollOptions[];

  /**
   * @generated from field: bool is_running = 5;
   */
  isRunning: boolean;

  /**
   * @generated from field: int64 created = 6 [jstype = JS_STRING];
   */
  created: string;

  /**
   * @generated from field: string created_by = 7;
   */
  createdBy: string;

  /**
   * @generated from field: string closed_by = 8;
   */
  closedBy: string;
};

/**
 * Describes the message plugnmeet.PollInfo.
 * Use `create(PollInfoSchema)` to create a new message.
 */
export const PollInfoSchema: GenMessage<PollInfo> = /*@__PURE__*/
  messageDesc(file_plugnmeet_polls, 3);

/**
 * @generated from message plugnmeet.SubmitPollResponseReq
 */
export type SubmitPollResponseReq = Message<"plugnmeet.SubmitPollResponseReq"> & {
  /**
   * @generated from field: string room_id = 1;
   */
  roomId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string poll_id = 4;
   */
  pollId: string;

  /**
   * @generated from field: uint64 selected_option = 5 [jstype = JS_STRING];
   */
  selectedOption: string;
};

/**
 * Describes the message plugnmeet.SubmitPollResponseReq.
 * Use `create(SubmitPollResponseReqSchema)` to create a new message.
 */
export const SubmitPollResponseReqSchema: GenMessage<SubmitPollResponseReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_polls, 4);

/**
 * @generated from message plugnmeet.ClosePollReq
 */
export type ClosePollReq = Message<"plugnmeet.ClosePollReq"> & {
  /**
   * @generated from field: string room_id = 1;
   */
  roomId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string poll_id = 3;
   */
  pollId: string;
};

/**
 * Describes the message plugnmeet.ClosePollReq.
 * Use `create(ClosePollReqSchema)` to create a new message.
 */
export const ClosePollReqSchema: GenMessage<ClosePollReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_polls, 5);

/**
 * @generated from message plugnmeet.PollResponsesResultOptions
 */
export type PollResponsesResultOptions = Message<"plugnmeet.PollResponsesResultOptions"> & {
  /**
   * @generated from field: uint64 id = 1 [jstype = JS_STRING];
   */
  id: string;

  /**
   * @generated from field: string text = 2;
   */
  text: string;

  /**
   * @generated from field: uint64 vote_count = 3 [jstype = JS_STRING];
   */
  voteCount: string;
};

/**
 * Describes the message plugnmeet.PollResponsesResultOptions.
 * Use `create(PollResponsesResultOptionsSchema)` to create a new message.
 */
export const PollResponsesResultOptionsSchema: GenMessage<PollResponsesResultOptions> = /*@__PURE__*/
  messageDesc(file_plugnmeet_polls, 6);

/**
 * @generated from message plugnmeet.PollResponsesResult
 */
export type PollResponsesResult = Message<"plugnmeet.PollResponsesResult"> & {
  /**
   * @generated from field: string question = 1;
   */
  question: string;

  /**
   * @generated from field: uint64 total_responses = 2 [jstype = JS_STRING];
   */
  totalResponses: string;

  /**
   * @generated from field: repeated plugnmeet.PollResponsesResultOptions options = 3;
   */
  options: PollResponsesResultOptions[];
};

/**
 * Describes the message plugnmeet.PollResponsesResult.
 * Use `create(PollResponsesResultSchema)` to create a new message.
 */
export const PollResponsesResultSchema: GenMessage<PollResponsesResult> = /*@__PURE__*/
  messageDesc(file_plugnmeet_polls, 7);

/**
 * @generated from message plugnmeet.PollsStats
 */
export type PollsStats = Message<"plugnmeet.PollsStats"> & {
  /**
   * @generated from field: uint64 total_polls = 1 [jstype = JS_STRING];
   */
  totalPolls: string;

  /**
   * @generated from field: uint64 total_running = 2 [jstype = JS_STRING];
   */
  totalRunning: string;
};

/**
 * Describes the message plugnmeet.PollsStats.
 * Use `create(PollsStatsSchema)` to create a new message.
 */
export const PollsStatsSchema: GenMessage<PollsStats> = /*@__PURE__*/
  messageDesc(file_plugnmeet_polls, 8);

/**
 * @generated from message plugnmeet.PollResponse
 */
export type PollResponse = Message<"plugnmeet.PollResponse"> & {
  /**
   * @generated from field: bool status = 1;
   */
  status: boolean;

  /**
   * @generated from field: string msg = 2;
   */
  msg: string;

  /**
   * @generated from field: optional string poll_id = 3;
   */
  pollId?: string | undefined;

  /**
   * @generated from field: optional uint64 total_responses = 4 [jstype = JS_STRING];
   */
  totalResponses?: string | undefined;

  /**
   * @generated from field: optional uint64 voted = 5 [jstype = JS_STRING];
   */
  voted?: string | undefined;

  /**
   * @generated from field: map<string, string> responses = 6;
   */
  responses: { [key: string]: string };

  /**
   * @generated from field: repeated plugnmeet.PollInfo polls = 7;
   */
  polls: PollInfo[];

  /**
   * @generated from field: optional plugnmeet.PollsStats stats = 8;
   */
  stats?: PollsStats | undefined;

  /**
   * @generated from field: optional uint64 total_polls = 9 [jstype = JS_STRING];
   */
  totalPolls?: string | undefined;

  /**
   * @generated from field: optional uint64 total_running = 10 [jstype = JS_STRING];
   */
  totalRunning?: string | undefined;

  /**
   * @generated from field: optional plugnmeet.PollResponsesResult poll_responses_result = 11;
   */
  pollResponsesResult?: PollResponsesResult | undefined;
};

/**
 * Describes the message plugnmeet.PollResponse.
 * Use `create(PollResponseSchema)` to create a new message.
 */
export const PollResponseSchema: GenMessage<PollResponse> = /*@__PURE__*/
  messageDesc(file_plugnmeet_polls, 9);

